import styled from 'styled-components';

// there is uses div instead main for support IE11
export const StyledMain = styled.div`
  padding-top: 160px;
`;
